/**
 * Version utility to get the current application version
 * Reads from package.json at build time
 */

// This will be replaced at build time with the actual version
// For development, we'll read from package.json dynamically
let cachedVersion: string | null = null;

export const getVersion = (): string => {
  if (cachedVersion) {
    return cachedVersion;
  }

  // In production build, version is injected via environment variable
  if (process.env.REACT_APP_VERSION) {
    cachedVersion = process.env.REACT_APP_VERSION;
    return cachedVersion;
  }

  // Fallback: try to read from package.json (works in development)
  try {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const packageJson = require('../../package.json');
    const version = packageJson.version || '0.0.1';
    cachedVersion = version;
    return version;
  } catch (error) {
    console.warn('Could not read version from package.json:', error);
    const defaultVersion = '0.0.1';
    cachedVersion = defaultVersion;
    return defaultVersion;
  }
};

export const formatVersion = (version: string): string => {
  return `v${version}`;
};
